module.exports = __webpack_public_path__ + "media/homepage/lendlease-a0489f95.png";